const Tag = ({ text, color = "vert", className = "" }) => (
  <span
    className={`bg-${color} tag text-blanc tag-text ${className}`}>
    {text}
  </span>
);

export default Tag;
